<template>
  <div class="retinuePage">
    <van-search
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入名称"
      show-action
      @input="onSearch"
      shape="round"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-content" id="list-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-radio-group v-model="radio">
          <van-cell-group>
            <van-cell
              v-for="item in retinueMainList"
              clickable
              :key="item.id"
              :title="`${item.realName}`"
              @click="selectitem(item)"
              class="item"
            >
              <van-radio slot="right-icon" :name="`${item.realName}`" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeRetinuePicker"
        >取消</a
      >
      <a href="javascript:void(0);" class="fl" @click="saveRetinue">确认</a>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/

export default {
  name: "redioRetinueView",
  data() {
    return {
      searchName: "",
      searchKeyword: "", //搜索的姓名人员
      total: "", //统计计算
      radio: "",
      retinueMainList: [],
      retinueList: [], //随行人员列表
      redioRetinuedata: {},
      page: 0,
      pageSize: 99,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      clientType: "", //手机类型
    };
  },
  props: {
    retinueUid: {
      type: String,
    },
  },
  mounted() {
    this.getPeopleList();
  },
  methods: {
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;
      _this.reloadPage();
    },
    onCancel() {
      let _this = this;
      this.searchName = "";
      _this.reloadPage();
    },
    getPeopleList() {
      let _this = this;
      if (
        _this.page != 0 &&
        _this.page * _this.pageSize >= parseInt(_this.commentCount)
      ) {
        return;
      }
      _this.page += 1;
      _this.$api.baseCommon.baseMsg.dictBox
        .staffPageList(_this.page, _this.pageSize, {
          realName: _this.searchName,
          enable: true,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.total = parseInt(res.data.total);
            _this.retinueList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            this.loading = false;
            if (_this.page * _this.pageSize >= _this.total) {
              _this.finished = true;
            } else {
              _this.getPeopleList();
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      let _this = this;
      _this.retinueMainList = _this.retinueMainList.concat(_this.retinueList);
      _this.retinueMainList.forEach((item) => {
        if (_this.retinueUid && _this.retinueUid == item.id) {
          _this.radio = item.realName;
          _this.redioRetinuedata = item;
        } else {
          _this.radio = "";
        }
      });
    },
    closeRetinuePicker() {
      this.redioRetinuedata = "";
      this.$emit("setReview", "");
    },
    selectitem(data) {
      let _this = this;
      console.log(data);
      _this.radio = data.realName;
      _this.redioRetinuedata = data;
    },
    saveRetinue() {
      let _this = this;
      this.$emit("setReview", _this.redioRetinuedata);
       this.radio = "";
    },

    reloadPage() {
      this.page = 0;
      this.retinueList = [];
      this.retinueMainList = [];
      this.loading = false; //是否处于加载状态
      this.finished = false; //是否已加载完所有数据
      this.getPeopleList();
    },
  },
  watch: {
    retinueUid: function (newVal) {
      if(newVal){
        this.retinueUid = newVal;
        this.reloadPage()
      }else{
        this.radio = "";
        this.retinueUid = "";
        this.reloadPage()
      }
    },
  },
};
</script>
<style lang="less" >
.retinuePage {
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,1);
  .searchBox {
    padding: 0 8px;
    background-color: rgba(255,255,255,1);
    position: relative;
    z-index: 99999999;
    padding-bottom: 10px;
  }
  .list-content {
    height: calc(100% - 95px);
    overflow-y: scroll;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .roleBtn {
    position: fixed;
    width: 100%;
    font-size: 0.42667rem;
    text-align: center;
    color: #333;
    height: 45px;
    bottom: 0;
    z-index: 999;
    background-color: #fff;
    border-top: 1px solid #f6f6f6;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>